import { createContext, useContext } from "react";
import { useTooltipLegacy } from "./useTooltipLegacy";
import { ThemeProviderContextProps } from "../../providers";

export type TooltipLegacyContextType =
  | (ReturnType<typeof useTooltipLegacy> & {
      theme?: ThemeProviderContextProps["theme"];
      mode?: ThemeProviderContextProps["mode"];
    })
  | null;

export const TooltipLegacyContext =
  createContext<TooltipLegacyContextType>(null);

export const useTooltipLegacyContext = () => {
  const context = useContext(TooltipLegacyContext);

  if (context == null) {
    throw new Error(
      "TooltipLegacy components must be wrapped in <TooltipLegacy />",
    );
  }

  return context;
};
